import styled, { css } from 'styled-components';

export default {
  Content: styled.span`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: block;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
    flex: 1;
    max-width: 100%;
    ${props => css`-webkit-line-clamp: ${props.maxLines ? props.maxLines : 'unset'};`}
    &:after {
      content: ${props => props.afterContent !== undefined ? `"${props.afterContent}"` : undefined};
      position: absolute;
      left: 0;
      top: 0;
    }
    &:before {
      content: ${props => props.beforeContent !== undefined ? `"${props.beforeContent}"` : undefined};
      position: absolute;
      right: 0;
      top: 0;
    }
  `
};
